<template>
  <div class="dropdown" :class="[{ disabled: step === 3 }]">
    <div class="dropdown-header" @click="toggleDropdown">
      <img v-if="selectedOption" :src="selectedOption.img" alt="" class="dropdown-image" />
      <div>
        <span>{{ selectedOption ? selectedOption.text : "בחר מתנה" }}</span>
      </div>
      <div>
        <div class="indicator">
          <template v-if="selectedOption">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="12px" height="11px">
              <path fill-rule="evenodd"  fill="#019CDE"
                    d="M3.516,8.154 L1.246,5.587 L-0.002,6.998 L2.993,10.385 L2.997,10.381 L3.544,10.999 L11.999,1.438 L10.726,-0.000 L3.516,8.154 Z"/>
            </svg>
          </template>
          <template v-else>
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 32 32">
              <title>plus</title>
              <path d="M30.075 14.080l-12.443 0.037v-12.2c0-1.061-0.856-1.917-1.92-1.917-1.061 0-1.917 0.856-1.917 1.917l0.037 12.163h-11.915c-1.064 0-1.92 0.853-1.92 1.917 0 1.061 0.856 1.917 1.92 1.917h11.896v12.163c0 1.061 0.856 1.917 1.92 1.917 1.061 0 1.917-0.856 1.917-1.917v-12.16h12.424c1.064 0 1.92-0.859 1.92-1.92 0-1.064-0.867-1.917-1.92-1.917z"></path>
            </svg>
          </template>
        </div>
      </div>
    </div>

<!--    <div>-->
<!--      <div v-if="isOpen" class="modal-overlay" @click="closeModal"></div>-->

<!--      <div v-if="isOpen" class="gifts-modal">-->
<!--        <div class="modal-content">-->
<!--          <div class="modal-header">-->
<!--            <img src="/client/img/gifts-logo.png" alt="gifts-logo" class="modal-image" />-->
<!--            <span class="modal-title">הריחבל תונתמ תמישר</span>-->
<!--            <img src="/client/img/gifts-close.png" alt="gifts-close" class="close-button" @click="closeModal" />-->
<!--          </div>-->
<!--          <ul class="dropdown-list">-->
<!--            <li-->
<!--              v-for="option in options"-->
<!--              :key="option.value"-->
<!--              class="dropdown-item">-->
<!--&lt;!&ndash;              @click="selectOption(option)"&ndash;&gt;-->
<!--&lt;!&ndash;            >&ndash;&gt;-->
<!--              <input-->
<!--                type="radio"-->
<!--                :id="option.value"-->
<!--                :value="option.value"-->
<!--                v-model="selectedOption"-->
<!--                class="dropdown-radio"-->
<!--              />-->
<!--              <label :for="option.value">-->
<!--                <img :src="option.img" alt="" class="dropdown-image" />-->
<!--                <span>{{ option.text }}</span>-->
<!--              </label>-->
<!--            </li>-->
<!--          </ul>-->
<!--          <button class="select-button" @click="confirmSelection">Выбрать</button>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <div>
      <div v-if="isOpen" class="modal-overlay" @click="closeModal"></div>

      <div v-if="isOpen" class="gifts-modal">


        <div class="modal-content">
          <div class="modal-header">
            <img src="/client/img/gifts-logo.png" alt="gifts-logo" class="modal-image" />
            <span class="modal-title">רשימת מתנות לבחירה</span>
            <img src="/client/img/gifts-close.png" alt="gifts-close" class="close-button" @click="closeModal" />
          </div>
          <ul class="dropdown-list">
            <li
              v-for="option in options"
              :key="option.value"
              class="dropdown-item"
              @click="selectOption(option)"
            >
              <img :src="option.img" alt="" class="dropdown-image" />
              <span>{{ option.text }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
<!--    <div>-->
<!--      <div-->
<!--        v-if="isOpen"-->
<!--        class="dropdown-overlay"-->
<!--        @click="closeDropdown"-->
<!--      ></div>-->
<!--      <div v-if="isOpen">-->
<!--&lt;!&ndash;        <div class="modal-header">&ndash;&gt;-->
<!--&lt;!&ndash;          <button class="close-button" @click="closeModal">×</button>&ndash;&gt;-->
<!--&lt;!&ndash;          <span class="modal-title">Заголовок модального окна</span>&ndash;&gt;-->
<!--&lt;!&ndash;          <img src="path/to/image.jpg" alt="Картинка справа" class="modal-image" />&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="modal-content">&ndash;&gt;-->
<!--          <ul class="dropdown-list">-->
<!--            <li-->
<!--              v-for="option in options"-->
<!--              :key="option.value"-->
<!--              class="dropdown-item"-->
<!--              @click="selectOption(option)"-->
<!--            >-->
<!--              <img :src="option.img" alt="" class="dropdown-image" />-->
<!--              <span>{{ option.text }}</span>-->
<!--            </li>-->
<!--          </ul>-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->

<!--    <ul v-if="isOpen" class="dropdown-list">-->
<!--      <li-->
<!--        v-for="option in options"-->
<!--        :key="option.value"-->
<!--        class="dropdown-item"-->
<!--        @click="selectOption(option)"-->
<!--      >-->
<!--        <img :src="option.img" alt="" class="dropdown-image" />-->
<!--        <span>{{ option.text }}</span>-->
<!--      </li>-->
<!--    </ul>-->
  </div>
</template>

<script setup>
import { ref, watch } from "vue";

const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  step: {
    type: Number,
    default: 1
  },
})

const isOpen = ref(false);
const selectedOption = ref(null);

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const selectOption = (option) => {
  selectedOption.value = option;
  updateGift(option);
  const giftProduct = document.querySelector('.gift-product');
  if (giftProduct){
    giftProduct.style.border = 'none';
  }
  document.querySelector('.gift-product').style.border = 'none';
  isOpen.value = false; // close dropdown after choice
};

const closeDropdown = () => {
  isOpen.value = false;
};

const closeModal = () => {
  isOpen.value = false; // close modal window
};

const updateGift = (option) => {
  axios.post(route('client.checkout.update-gift'), {gift: option});
}

watch(
  () => props.options,
  (newOptions) => {
    if (!newOptions.some((option) => option.value === selectedOption.value?.value)) {
      selectedOption.value = null;
      updateGift(selectedOption.value);
    }
  },
  { deep: true, immediate: true }
);

</script>

<style scoped lang="scss">

.gifts-modal {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 740px;
  height: 425px;
  background: #fff;
  //border-radius: 10px;
  box-shadow: -4px 4px 15px rgba(0, 0, 0, 0.25);
  z-index: 101;
  overflow: hidden;
  @media (max-width: 769px) {
    top: 45%;
    width: 96%;
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.25); /* Затемнение */
  z-index: 100;
}

.modal-content {
  //padding: 20px;
}

.modal-header {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  //padding: 10px;
  //border-bottom: 1px solid #ccc;
  background-color: #F2F2F2;
}

//
//.modal-header {
//  display: flex;
//  align-items: center;
//  justify-content: space-between;
//  padding: 10px 15px;
//  border-bottom: 1px solid #ccc;
//}

.modal-title {
  padding-right: 20px;
  padding-left: 20px;
  width: 660px;
  font-family: 'Arimo', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 1; /* 100% */
  letter-spacing: 0; /* 0% от размера шрифта */
  text-align: right;
  //vertical-align: middle;
  text-transform: uppercase;
  color: #000000;
  //font-size: 20px;
  //font-weight: bold;
}

.close-button {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 25px;
  left: 20px;
  //background: none;
  //border: none;
  //font-size: 20px;
  //color: #91A7C6;
  //cursor: pointer;
}

//.modal-image {
//  width: 40px;
//  height: 40px;
//  border-radius: 50%;
//}

/************************/

//.dropdown-overlay {
//  position: fixed; /* Фиксированное позиционирование для покрытия всей страницы */
//  top: 0;
//  left: 0;
//  width: 100%;
//  height: 100%;
//  background-color: rgba(0, 0, 0, 0.5); /* Полупрозрачный чёрный фон */
//  z-index: 100; /* Убедитесь, что он ниже выпадающего списка */
//}

.dropdown {
  width: 100%;
  position: relative;
  font-family: Arial, sans-serif;
  user-select: none;
}

.dropdown-header {
  border: 1px solid #ccc;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  cursor: pointer;
  height: 66px;
  span {
    font-family: 'Arimo', sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 1; /* 100% */
    letter-spacing: 0; /* 0% от размера шрифта */
    text-align: right;
    vertical-align: middle;
    text-transform: uppercase;
    color: #888888;
  }
}
.dropdown-image {
  width: 60px;
  height: 60px;
}
//.arrow {
//  margin-left: auto;
//}

/*****************************/
//.dropdown-list {
//  position: absolute;
//  top: -334px;
//  right: -100%;
//  width: 100%;
//  border: 1px solid #ccc;
//  background: #fff;
//  z-index: 102;
//  list-style: none;
//  margin: 0;
//  padding: 0;
//  //height: 175px;
//  height: auto;
//  max-height: 400px;
//  overflow: overlay;
//
//  @media (max-width: 769px) {
//    top: 100%;
//    left: 0;
//    right: 0;
//  }
//}
//.dropdown-item {
//  padding: 10px;
//  display: flex;
//  align-items: center;
//  cursor: pointer;
//}
//.dropdown-item:hover {
//  background: #f0f0f0;
//}

/*****************************/

.indicator {
  padding-left: 20px;
  padding-right: 10px;
}

.dropdown-list {
  width: 100%;
  border: 1px solid #ccc;
  background: #fff;
  list-style: none;
  margin: 20px 0 20px 0;
  padding: 0 20px 0 20px;
  height: auto;
  max-height: 320px;
  overflow: overlay;

  //@media (max-width: 769px) {
  //  top: 100%;
  //  left: 0;
  //  right: 0;
  //}
}
.dropdown-item {
  padding: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.dropdown-item:hover {
  background: #f0f0f0;
}

</style>
